/* istanbul ignore file */
import { v4 } from 'uuid';
import hash from 'object-hash';
import { getSelectedProduct, getProducts } from '@americanexpress/product-ducks';
import getFaasUrl from './getFaasUrl';

import getMapsOneDataCallDetails from './getMapsOneDataCallDetails';
import getCacheStrategyDetails from './getCacheStrategyDetails';

function getHipedAccountToken(state) {
  const selectedProduct = getSelectedProduct(state);
  const productsList = getProducts(state);
  return selectedProduct && productsList && productsList[selectedProduct]
    && productsList[selectedProduct].hipedAccountToken
    ? productsList[selectedProduct].hipedAccountToken
    : selectedProduct;
}

const createMapsOneDataProcedureConfig = (
  functionName, parseResult
) => ({
  call: async ({
    fetchClient,
    getState,
    args,
  }) => {
    let reqID = v4();

    if (functionName.includes('CreateMerchantMapLogImpression')) {
      const uuid = `maps${Date.now()}${Array.from({ length: 12 }, () => '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 62)]
      ).join('')}`;
      reqID = uuid;
    }

    let apiKey = getSelectedProduct(getState());
    if (functionName.includes('ReadMerchantMapIndustryBonusCategories')
    || functionName.includes('ReadMerchantMapRecommendation')) {
      apiKey = getHipedAccountToken(getState());
    }

    const callDetails = getMapsOneDataCallDetails(functionName, reqID, args, getState, apiKey);
    const { oneDataFunctionName } = callDetails;
    const { callCondition } = callDetails;
    const { includeCredentials } = callDetails;
    const { requestBody } = callDetails;

    let fetchOpts = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'one-data-correlation-id': reqID,
      },
      body: JSON.stringify(requestBody),
    };
    if (includeCredentials) {
      fetchOpts = { ...fetchOpts, credentials: 'include' };
    }
    if (callCondition) {
      return fetchClient(`${getFaasUrl(getState())}/${oneDataFunctionName}`, fetchOpts)
        .then((response) => {
          if (response.ok) {
            return response;
          }
          return response.text().then((text) => {
            throw new Error(text);
          });
        })
        .then((res) => res.json());
    }
    return Promise.resolve(false);
  },
  getResultFromCache: ({ args, cache }) => {
    const cacheStrategy = getCacheStrategyDetails(functionName, args);
    const hashedArgs = cacheStrategy.doHash
      ? hash(cacheStrategy.cacheArgs) : cacheStrategy.cacheArgs;

    if (!cache.has(hashedArgs) || (args.query.enrolledOffers || args.forceFetch)) {
      throw new Error('make the call');
    }
    return cache.get(hashedArgs);
  },
  buildUpdatedCache: ({
    cache, args, result, error,
  }) => {
    const cacheStrategy = getCacheStrategyDetails(functionName, args);
    const hashedArgs = cacheStrategy.doHash
      ? hash(cacheStrategy.cacheArgs) : cacheStrategy.cacheArgs;
    if (cacheStrategy.simpleReturn) {
      return cache.set(hashedArgs, (error && 'fail') || (result && 'pass'));
    }
    return typeof result === 'undefined' && typeof error === 'undefined'
      ? cache.remove(hashedArgs)
      : cache.set(hashedArgs,
        error || (parseResult ? parseResult(result) : result));
  },
});

export default createMapsOneDataProcedureConfig;
